/**
 * @generated SignedSource<<0cdc30fd9aa484d349313dd0fa589833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MovieLandingPageLatestMovieQuery$data = {
  readonly latest_entities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cover_url: string;
        readonly id: string;
        readonly name: string;
        readonly original_name: string | null;
      };
    } | null> | null;
  };
  readonly " $fragmentType": "MovieLandingPageLatestMovieQuery";
};
export type MovieLandingPageLatestMovieQuery$key = {
  readonly " $data"?: MovieLandingPageLatestMovieQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"MovieLandingPageLatestMovieQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MovieLandingPageLatestMovieQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "kind",
          "value": "movie"
        }
      ],
      "concreteType": "MovieConnection",
      "kind": "LinkedField",
      "name": "latest_entities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MovieEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Movie",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "original_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cover_url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "latest_entities(kind:\"movie\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "57755967979f0d4c5fccfb288782f08d";

export default node;
